import moment from "moment";
import type { Campaign } from "../../../cores/advertisements/interfaces/api/get-campaigns";
import type { CampaignFilterDraft } from "./CampaignsFilterPopover";

const ACTIVE_LIKE = ["ACTIVE", "IN_PROCESS", "PREAPPROVED", "PENDING_REVIEW"];
const PAUSED_LIKE = ["PAUSED", "CAMPAIGN_PAUSED", "ADSET_PAUSED"];
const RETIRED_LIKE = [
  "ARCHIVED",
  "DELETED",
  "COMPLETED",
  "DISAPPROVED",
  "WITH_ISSUES",
];

function statusMatchesSelection(status: string, f: CampaignFilterDraft): boolean {
  const allOn = f.statusActive && f.statusPaused && f.statusRetired;
  if (allOn) return true;
  if (!f.statusActive && !f.statusPaused && !f.statusRetired) return false;
  if (f.statusActive && ACTIVE_LIKE.includes(status)) return true;
  if (f.statusPaused && PAUSED_LIKE.includes(status)) return true;
  if (f.statusRetired && RETIRED_LIKE.includes(status)) return true;
  return false;
}

/** Filtros de estado, plataforma y rango sobre fecha de inicio de campaña. */
export function campaignMatchesToolbarFilters(
  campaign: Campaign,
  f: CampaignFilterDraft,
  dateRange: [Date, Date] | null
): boolean {
  if (!f.platformMeta) return false;
  if (!statusMatchesSelection(campaign.status, f)) return false;
  if (dateRange) {
    const [from, to] = dateRange;
    const t = moment(campaign.startTime);
    if (t.isValid()) {
      const ok = t.isBetween(
        moment(from).startOf("day"),
        moment(to).endOf("day"),
        undefined,
        "[]"
      );
      if (!ok) return false;
    }
  }
  return true;
}
